import React from "react";
import { Link } from "react-router-dom";

// [Trust] [SEO/GEO] Footer → Bricks footer template. Hours, ABN and social links omitted until verified.
const LOGO_SRC = "https://cdn.magicpatterns.com/uploads/wfGFQpbMXGFxGofAbTAYd5/Oceanside_logo_transparent_PNG.png";
const exploreLinks = [{
  label: "Home designs",
  to: "/home-designs"
}, {
  label: "Our work",
  to: "/projects"
}, {
  label: "Our building process",
  to: "/our-process"
}, {
  label: "Pricing & inclusions",
  to: "/#inclusions"
}, {
  label: "FAQs",
  to: "/#faqs"
}, {
  label: "About us",
  to: "/about"
}, {
  label: "Book a consultation",
  to: "/contact"
}];
const serviceLinks = [{
  label: "Home designs & single-storey builds",
  to: "/#home-designs-service"
}, {
  label: "Custom homes",
  to: "/#custom-homes"
}, {
  label: "Knock-down/rebuilds",
  to: "/#knock-down-rebuild"
}, {
  label: "Rear-block homes",
  to: "/#rear-block-homes"
}, {
  label: "Developments",
  to: "/#developments"
}];
export function Footer() {
  return <footer className="border-t border-line bg-paper-deep" data-id="element-33" data-mp="2kcl3va4mcnwp">
      <div className="mx-auto max-w-site px-5 py-14 md:px-10 md:py-20" data-id="element-34" data-mp="2kb0ctuhijn3l">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12" data-id="element-35" data-mp="2p5e9e07ww09u">
          <div className="lg:col-span-4" data-id="element-36" data-mp="2bd7uehghvzbz">
            <Link to="/" aria-label="Oceanside Living home" className="inline-block" data-id="element-37" data-mp="2be9e1abktu5b">
              <img src={LOGO_SRC} alt="Oceanside Living" width={2576} height={1394} className="h-16 w-auto" loading="lazy" data-id="element-38" data-mp="2gc15k38b7e8z" />
            </Link>
            <p className="mt-6 max-w-xs text-[16px] leading-relaxed text-slate" data-id="element-39" data-mp="382ffxph468fw">
              Owner-led new and custom home builders in Perth. Fixed-price contracts and homes built as if they were our own.
            </p>
          </div>

          <nav aria-label="Explore" className="lg:col-span-2" data-id="element-40" data-mp="2z0ppalv23dj6">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-41" data-mp="1io0tjbtkixnk">Explore</h2>
            <ul className="mt-4 space-y-3 text-[15px]" data-id="element-42" data-mp="1iq3wewftkl9p">
              {exploreLinks.map(link => <li key={link.label} data-id="element-43" data-mp="1nkhl6fzz7u5e">
                  <Link to={link.to} className="text-slate hover:text-charcoal hover:underline hover:underline-offset-4" data-id="element-44" data-mp="13kzg6qs81az0">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="What we build" className="lg:col-span-3" data-id="element-45" data-mp="uqb8yv335j7k">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-46" data-mp="psjkyc5kah8n">What we build</h2>
            <ul className="mt-4 space-y-3 text-[15px]" data-id="element-47" data-mp="kuhz5jgr43th">
              {serviceLinks.map(link => <li key={link.label} data-id="element-48" data-mp="fu3ri2j2avvz">
                  <Link to={link.to} className="text-slate hover:text-charcoal hover:underline hover:underline-offset-4" data-id="element-49" data-mp="fx9hdjzim1sr">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-50" data-mp="267ujz9mwqqgo">
            <h2 className="text-sm font-semibold text-charcoal" data-id="element-51" data-mp="266t6kyif5rvs">Contact</h2>
            <address className="mt-4 space-y-3 text-[15px] not-italic text-slate" data-id="element-52" data-mp="219t2uu91l17u">
              <p data-id="element-53" data-mp="28sshkmlk64kv">
                <a href="tel:+61862850876" className="text-charcoal underline underline-offset-4" data-id="element-54" data-mp="28r7mmvvc0jmh">08 6285 0876</a>
              </p>
              <p data-id="element-55" data-mp="2dor2u1blb6h2">
                <a href="mailto:admin@oceansideliving.com.au" className="break-all text-charcoal underline underline-offset-4" data-id="element-56" data-mp="2ii2csbbp83d7">
                  admin@oceansideliving.com.au
                </a>
              </p>
              <p data-id="element-57" data-mp="1ptod7r4yoyzj">9/30 Dellamarta Road<br data-id="element-58" data-mp="1pu6i1c5owlj2" />Wangara WA 6065</p>
              <p data-id="element-59" data-mp="1pv9avpmkoy1m">Builder registration BC 103813</p>
            </address>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-line pt-6 text-sm text-slate md:flex-row md:justify-between" data-id="element-60" data-mp="1uuc5sh8u9nvv">
          <p data-id="element-61" data-mp="23snz4r13azs0">© {new Date().getFullYear()} Oceanside Living</p>
          <p data-id="element-62" data-mp="23qtfdg1k1dpi">Perth, Western Australia</p>
        </div>
      </div>
    </footer>;
}